import React, { useContext } from 'react';
import { Row, Col } from '@thd-olt-component-react/grid';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Image } from '@thd-olt-component-react/core-ui';
import { Heading } from '@thd-olt-component-react/heading';
import {
  params,
  shape as shapeType,
  fragment,
  customType,
  string,
  useDataModel,
  arrayOf as arrayType
} from '@thd-nucleus/data-sources';
import { arrayOf, shape, string as stringType } from 'prop-types';
import { track } from './related-search-analytics';
import './popularCategories.scss';

const PopularCategoriesList = ({
  navigationList
}) => {
  return (
    <div className="popular-categories__links">
      {navigationList?.map((popCat, index) => {
        const url = popCat.paramLink;
        const copyText = popCat?.title;
        return (
          <span className="popular-categories__elements" key={`popcat-${copyText}${index}`}>
            <Image
              src="https://assets.thdstatic.com/images/v1/magnify-tilted-left-grey.svg"
              className="popular-categories__elements__magnify-symbol"
              height="14"
              width="14"
            />
            <a className="bttn--inline" href={url} onClick={() => track(copyText)}>
              <span className="popular-categories__elements-text">{copyText}</span>
            </a>
          </span>
        );
      })}
    </div>
  );
};

const PopularCategories = ({
  componentId,
  componentClass,
  popCatId
}) => {
  const { channel } = useContext(ExperienceContext);
  const {
    data,
    loading,
    error
  } = useDataModel('emtPopularCategories', {
    variables: {
      id: popCatId.length < 4 ? `0${popCatId}` : popCatId,
    }
  });

  const title = 'Popular Categories';
  const navigationList = data?.emtPopularCategories?.popularCategoryList;

  if (!data || loading || error) {
    return null;
  }

  const headingProps = { underline: true, title };
  if (channel !== 'mobile') headingProps.centered = true;
  return (
    <Row className="popular-categories" data-component="PopularCategories">
      <Col>
        {/* eslint-disable react/jsx-props-no-spreading */}
        <Heading {...headingProps} />
        <PopularCategoriesList navigationList={navigationList} />
      </Col>
    </Row>
  );
};

PopularCategories.displayName = 'PopularCategories';

PopularCategories.propTypes = {
  componentId: stringType.isRequired,
  componentClass: stringType,
  popCatId: stringType
};

PopularCategories.defaultProps = {
  componentClass: '',
  popCatId: ''
};
PopularCategoriesList.propTypes = {
  navigationList: arrayOf(shape({}))
};

PopularCategoriesList.defaultProps = {
  navigationList: []
};

PopularCategories.dataModel = {
  component: params({
    id: string()
      .isRequired(),
    componentClass: customType('ComponentClass')
      .enum(['PopularCategories'])
      .isRequired(),
  })
    .shape({
      PopularCategories: fragment()
        .shape({
          id: string(),
          componentName: string(),
          navigationList: arrayType(shapeType({
            id: string(),
            title: string(),
            link: string(),
          }))
        }),
    }),
  emtPopularCategories: params({ id: string().isRequired() }).shape({
    popularCategoryList: arrayType(shapeType({
      title: string(),
      link: string(),
      paramLink: string()
    }))
  })
};

export { PopularCategories };
